/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { storiesUpdate } from '../../axios/storiesUpdate'
import type {
	StoriesUpdateError,
	StoriesUpdatePathParams,
	StoriesUpdateRequest,
	StoriesUpdateResponse,
} from '../../types/StoriesUpdate'

export const storiesUpdateMutationKey = () => [{ url: '/ad-generation/stories/:story' }] as const

export type StoriesUpdateMutationKey = ReturnType<typeof storiesUpdateMutationKey>

export type StoriesUpdateVariables = {
	story: StoriesUpdatePathParams['story']
	data: StoriesUpdateRequest
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/StoryController.php StoryController::update */
export function useStoriesUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		StoriesUpdateResponse,
		AxiosError<StoriesUpdateError>,
		StoriesUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: storiesUpdateMutationKey(),
		mutationFn: ({ story, data }: StoriesUpdateVariables) =>
			storiesUpdate(story, data, config).then(res => res.data),
		...options,
	})
}
